import { useChatWootStore } from "stores/chatwoot";
import "./styles.sass";

// eslint-disable-next-line @typescript-eslint/ban-types
type ChatwootLoadingProps = {};

// eslint-disable-next-line unused-imports/no-unused-vars
const ChatwootLoading = (props: ChatwootLoadingProps) => {
  const setIsLoaidng = useChatWootStore((state) => state.setIsLoading);

  return (
    <div className="ChatwootLoading" onClick={() => setIsLoaidng(false)}>
      <div className="ChatwootLoading__loader" />
    </div>
  );
};

export default ChatwootLoading;
